import { render, staticRenderFns } from "./AcaoSocial.vue?vue&type=template&id=738c3c7c&scoped=true&"
import script from "./AcaoSocial.vue?vue&type=script&lang=js&"
export * from "./AcaoSocial.vue?vue&type=script&lang=js&"
import style0 from "./AcaoSocial.vue?vue&type=style&index=0&id=738c3c7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738c3c7c",
  null
  
)

export default component.exports